import axios from 'axios';
import apiUrl from 'config/api';

import {
  FETCH_SERIES,
  FETCH_SERIES_SUCCESS,
  FETCH_SERIES_FAIL,
  SET_CURRENT_SERIE,
  NEXT_QUESTION,
  FETCH_SERIE_RESULT,
  FETCH_SERIE_RESULT_SUCCESS,
  FETCH_SERIE_RESULT_FAIL
} from 'config/types';

export const fetchSeries = ({onSuccess}) => dispatch => {
  dispatch({ type: FETCH_SERIES });

  return axios({
    method: 'GET',
    url: `${apiUrl}/series`,
  })
    .then(({ data }) => dispatch({ type: FETCH_SERIES_SUCCESS, payload: data }))
    .then(onSuccess)
    .catch(error => dispatch({ type: FETCH_SERIES_FAIL, error }));
};

export const setCurrentSerie = (id) => dispatch => {
  dispatch({ type: SET_CURRENT_SERIE, payload: id});
}

export const nextQuestion = (questionId) => dispatch => {
  dispatch({ type: NEXT_QUESTION, payload: questionId });
}

export const fetchSerieResult = (id, {onSuccess}) => dispatch => {
  dispatch({ type: FETCH_SERIE_RESULT });

  return axios({
    method: 'GET',
    url: `${apiUrl}/serie/${id}/result`,
  })
    .then(({ data }) => dispatch({ type: FETCH_SERIE_RESULT_SUCCESS, payload: data }))
    .then(onSuccess)
    .catch(error => dispatch({ type: FETCH_SERIE_RESULT_FAIL, error }));
};